import { each as _each, find, sortBy } from 'lodash-es';

/**
 * Native port of the v1 `languageHelper` factory + `defaultLanguage` provider
 * (account-v1/src/core/language/language.js). WS5 #10 Stage A inc 2s.
 *
 * `defaultLanguage` is a CONSTANT 'en': the v1 provider defaults to 'en' and
 * `defaultLanguageProvider.set` has ZERO callers tree-wide (verified #108).
 *
 * Verbatim semantics (lodash, not Array natives, on purpose):
 * - sortByDefaultLanguage: stable `sortBy` with the v1 iteratee quirk — the
 *   default language sorts by the STRING '0' while the rest sort by their
 *   `name`, so 'en' lands first only because '0' < any letter.
 * - merge: upsert `{code, name}` into `to` for each entry of `from`
 *   (`find` object-matcher on `code`).
 */
export const DEFAULT_LANGUAGE = 'en';

export const languageHelper = {
  sortByDefaultLanguage(languages: any): void {
    if (languages && languages.item) {
      languages.item = sortBy(languages.item, (lang: any) =>
        lang.code === DEFAULT_LANGUAGE ? '0' : lang.name,
      );
    }
  },

  merge(to: any[], from: any[]): void {
    _each(from, (f: any) => {
      const existent = find(to, { code: f.code });
      if (!existent) {
        to.push({ code: f.code, name: f.name });
      } else {
        existent.name = f.name;
      }
    });
  },
};
